import React from 'react';
import classnames from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import classes from './bottom-buttons.scss';
export default function BottomButtons({
  onBackButton,
  isDisabledNextButton = false,
  isDisabledBackButton = false,
  onNextButton,
  buttonsWrapperClassName = '',
  backText = 'Back',
  nextText = 'Continue'
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.buttonsWrapper, buttonsWrapperClassName)
  }, /*#__PURE__*/React.createElement(Button, {
    dataButton: "Back",
    type: "defaultGrey",
    disabled: isDisabledBackButton,
    className: classes.back,
    onClick: onBackButton
  }, backText), /*#__PURE__*/React.createElement(Button, {
    dataButton: "Continue",
    type: "primary",
    disabled: isDisabledNextButton,
    onClick: onNextButton
  }, nextText));
}